<template>
  <div id="app">
    <el-row id="preview">
      <el-col :span="24" class="dashboard_wrapper">
        <div
            class="dashboard"
            :style="getStyle(board.background)"
            @click="onDashboardClick"
        >
          <div
              :key="item.id"
              class="equipItem "
              :class="'equipItem_' + item.id"
              v-for="item of board.equips"
              :style="getStyle(item)"
          >
            <div class="text">{{ item.title }}</div>

            <!-- <el-popover
              placement="top"
              width="400"
              trigger="click"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
              <div class="text" slot="reference">{{ item.title }}</div>
            </el-popover> -->
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {fetchLayoutData} from '@/service/layoutDataService';
import {getEuipment} from '@/service/equipmentService';

import {getStyle} from '@/util/utils';

export default {
  name: 'app',
  data: () => {
    return {
      currentItem: null,
      layoutData: {
        id: '',
        title: '加载中',
      },
      equipments: [],
      equipmentsMap: new Map(),
      board: {
        equips: [],
        background: {
          width: '1200',
          height: '900',
        },
      },
      xLeft: '',
      yTop: '',
      showPop: false,
      screenWidth: document.body.clientWidth,// 屏幕宽
      screeHeight: document.body.clientHeight,// 屏幕高

      workOrderList: [],
      andonList: []
    };
  },
  computed: {
    boardStyle: function () {
      return {
        width: this.board.background.width + 'px',
        height: this.board.background.height + 'px',
      };
    },
  },

  async mounted() {
    const {id} = this.$route.params;
    if (!id) {
      this.$message('ID 出错,请重新进入!');
    }
    const layoutData = await fetchLayoutData(id);
    console.log('12345',layoutData)
    this.layoutData = {id: layoutData.data.data.rowid, title: layoutData.data.data.workshop};
    try {
      const raw = JSON.parse(layoutData.data.data.raw);
      if (raw.background && raw.equips) {
        this.board = raw;
      }
    } catch (e) {
      this.$message('解析失败!');
    }
    const equipments = await getEuipment();
    console.log('equipments11',equipments.data.data.rows)
    this.equipments=equipments.data.data.rows.map(item =>({ 
      id:item.rowid,
      title:item.sbmc,
      no:item.equ_no,
      status:item.sbzt
    }))
    if (this.equipments) {
      this.equipments.forEach(item => {
        this.equipmentsMap.set(item.no, item);
        return {
          id: item.id,
          title: item.title,
          no: item.no,
          style: {},
          status: item.status,
          type: 'equip',
        };
      });
      this.$forceUpdate()
    }
  },
  methods: {
    async onDashboardClick(event) {
      this.currentItem = null;
      console.log('event-onDashboardClick', event);
      let tp = document.querySelector(".popoverContant");
      if (tp) {
        if (!tp.contains(event.target)) {
          this.showPop = false;
        }
      }
    },

    getStyle(item) {
      console.log()
      return getStyle(item, this.equipmentsMap);
    },
  },
  watch: {},
};
</script>

<style>
.green {
  color: #519779;
}

.red {
  color: #851d2b;
}

.orange {
  color: #cd6820;
}

.popoverContant {
  position: fixed;
  z-index: 999;
  width: 500px;
  min-height: 300px;
}

.popoverMain {
  width: 100%;
  background: #fff;
  padding: 3%;
  box-sizing: border-box;
  border-radius: 10px;
  margin: 20px;
  height: 300px;
  overflow-y: scroll;
}

.popoverNone > img {
  display: block;
  margin: 0 auto;
}

.popoverNone > div {
  color: #797575;
  margin-top: 5%;
  justify-content: center;
}

.popoverMain > div:last-child {
  border-bottom: none !important;
}

.popoverLists {
  width: 100%;
  border-bottom: 1px solid #9e9e9e;
}

.popoverLists > div {
  display: flex;
  align-items: center;
  margin: 3% 0;
  text-align: left;
}

.popoverLists > div > div {
  flex: 1;
}

.popoverTitle > img {
  display: inline-block;
  margin-right: 3%;
}
</style>
